import { writable } from "svelte/store";

export const tempStore = writable({});
